import * as React from "react";
import { ToggleButton, ToggleButtonGroup, Typography, Box } from "@mui/material";
import { Controller } from "react-hook-form";

export default function FormToggleButtonGroup({
  fieldname,
  control,
  options,
  label,
  rules,
  defaultValue = [],
  exclusive = false,
  required = false,
  disabled = false,
  helperText = null,
  boldLabel = false,
  textColor,
  sx,
}) {
  const combinedRules = required
    ? { ...rules, required: "This field is required" }
    : rules;

  return (
    <Controller
      name={fieldname}
      control={control}
      rules={combinedRules}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box>
          {label && (
            <Typography
              variant="body1"
              fontWeight={boldLabel ? "bold" : "normal"}
              color={textColor || "inherit"}
            >
              {label} {required && <span style={{ color: "red" }}>*</span>}
            </Typography>
          )}

          <ToggleButtonGroup
            value={value}
            exclusive={exclusive}
            onChange={(_, newValue) => {
              // prevent clearing all if required
              if (required && exclusive && newValue === null) return;
              onChange(newValue);
            }}
            disabled={disabled}
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))", // responsive
              width: "100%",
              ...sx,
            }}
          >
            {options.map((opt) => (
              <ToggleButton
                key={opt.value}
                value={opt.value}
                disabled={opt.disabled}
                size="small"
                sx={{
                  width: "100%", // take full cell width

                  ":hover": {
                    backgroundColor: (theme) => theme.palette.primary.light,
                  },
                  "&.Mui-selected": {
                    backgroundColor: (theme) => theme.palette.secondary.light,
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: (theme) => theme.palette.primary.light,
                  },
                }}
              >
                {opt.icon || opt.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>

          {(error || helperText) && (
            <Typography
              variant="caption"
              color={error ? "error" : "textSecondary"}
              sx={{ whiteSpace: "pre-line", mt: 0.5, display: "block" }}
            >
              {error ? error.message : helperText}
            </Typography>
          )}
        </Box>
      )}
    />
  );
}
